
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Demographics } from '../../classes/markets/class.demographics';
import { Countries } from '../../classes/markets/class.countries';
import { Accounts } from '../../classes/markets/class.accounts';
import { Report } from '../../classes/markets/class.report';
import { Categories } from '../../classes/markets/class.categories';





import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HttpService {


    private countriesUrl = environment.marketReportsUrl  + '/api/Lookup_Countries';
    private accountsUrl = environment.marketReportsUrl  + '/api/Accounts';
    private ytdReport = environment.marketReportsUrl  + '/api/Locations/getAll';
    // tslint:disable-next-line:max-line-length
    private categoryUrl = environment.marketReportsUrl  + '/api/Lookups?filter=%7B%22where%22%3A%7B%22category%22%3A%22classification%22%2C%20%22type%22%3A%22account%22%7D%7D';

  constructor(private http: HttpClient) { }

  // Methods using obsevables
  getCountriesObservable(): Observable<Countries[]> {
   return this.http
      .get(this.countriesUrl).pipe(
      map(response => response as Countries[]),
      catchError((e) => {
        return observableThrowError(
          new Error(`${ e.status } ${ e.statusText }`)
        );
      }));
   }


  getAccountsObservable(countryId: any, sectorId: any): Observable<Accounts[]> {
  return this.http
      .get(this.accountsUrl + '/byClassification?country-id=' + countryId + '&classification-id=' + sectorId).pipe(
      map(response => response as Accounts[]),
      catchError((e) => {
        return observableThrowError(
          new Error(`${ e.status } ${ e.statusText }`)
        );
      }));
      /*return this.http
      .get(this.accountsUrl)
      .map(response => response.json() as Demographics[])
      .catch((e) => {
        return Observable.throw(
          new Error(`${ e.status } ${ e.statusText }`)
        );
      });*/
  }

    getCategoriesObservable(): Observable<Categories[]> {
        return this.http
            .get(this.categoryUrl).pipe(
            map(response => response as Categories[]),
            catchError((e) => {
            return observableThrowError(
                new Error(`${ e.status } ${ e.statusText }`)
            );
        }), );
    }

    // tslint:disable-next-line:max-line-length
    getReportObservable(countryID: any, accountIDs: any, statusID: any, dateOpenYTDFrom: any, dateOpenYTDTo: any, dateClosedYTDFrom: any, dateClosedYTDTo: any, sectorID: any): Observable<Report[]> {

        dateOpenYTDFrom = this.formatDate(dateOpenYTDFrom);
        dateOpenYTDTo = this.formatDate(dateOpenYTDTo);
        dateClosedYTDFrom = this.formatDate(dateClosedYTDFrom);
        dateClosedYTDTo = this.formatDate(dateClosedYTDTo);
        // sectorID = 36;

        return this.http
            // tslint:disable-next-line:max-line-length
            .get(this.ytdReport + '?countryID=' + countryID + '&accountIDs='  + accountIDs + '&statusID=' + statusID + '&dateOpenYTDFrom=' + dateOpenYTDFrom + '&dateOpenYTDTo=' + dateOpenYTDTo + '&dateClosedYTDFrom=' + dateClosedYTDFrom + '&dateClosedYTDTo=' + dateClosedYTDTo + '&sectorID=' + sectorID).pipe(
            map(response => response as Report[]),
            catchError((e) => {
            return observableThrowError(
                new Error(`${ e.status } ${ e.statusText }`)
            );
        }), );
   }



  // Methods using Promises

  // tslint:disable-next-line:max-line-length
  getReport(countryID: any, accountID: any, statusID: any, dateOpenYTDFrom: any, dateOpenYTDTo: any, dateClosedYTDFrom: any, dateClosedYTDTo: any, reportType: any): Promise<Report[]> {
    // dateOpenYTDFrom = this.formatDate(dateOpenYTDFrom);
    // dateOpenYTDTo = this.formatDate(dateOpenYTDTo);
    // dateClosedYTDFrom = this.formatDate(dateClosedYTDFrom);
    // dateClosedYTDTo = this.formatDate(dateClosedYTDTo);

// tslint:disable-next-line:max-line-length
//    return this.http.get(this.ytdReport+'?countryID='+countryID+'&accountID='+accountID+'&statusID='+statusID+'&dateOpenYTDFrom='+dateOpenYTDFrom+'&dateOpenYTDTo='+dateOpenYTDTo+'&dateClosedYTDFrom='+dateClosedYTDFrom+'&dateClosedYTDTo='+dateClosedYTDTo+'&reportType='+reportType)
     return this.http.get(this.ytdReport)
               .toPromise()
               .then(response => response as Report[])
               .catch(this.handleError);
  }


//   private getHeaders(classifications: any){
//     let headers = new Headers();
//     headers.append('Accept', 'application/json');
//     return headers;
//   }

  // Error handling
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
  return Promise.reject(error.message || error);
  }

  private formatDate(date: any) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

      if (month.length < 2) { month = '0' + month; }
      if (day.length < 2) { day = '0' + day; }

      return [year, month, day].join('-');
  }
}
